import {
  faMoon,
  faSunBright,
} from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { cn } from '../lib/utils';

import { Button } from './button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './tooltip';

interface Props {
  className?: string;
  mode: 'dark' | 'light';
  onClick?: () => void;
}

export const ModeToggle = ({ className, mode = 'dark', onClick }: Props) => {
  const isDarkMode = mode === 'dark';

  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild tabIndex={-1}>
          {/* tabIndex prevents tooltip from opening on focus */}
          <Button
            className={cn(
              'vai-overflow-hidden !vai-size-7 vai-rounded-md',
              className,
              {
                'hover:!vai-bg-[rgba(255,255,255,0.1)]': isDarkMode,
                'hover:!vai-bg-[rgba(0,0,0,0.1)]': !isDarkMode,
              },
            )}
            variant="ghost"
            size="icon"
            onClick={onClick}
          >
            <FontAwesomeIcon
              icon={isDarkMode ? faSunBright : faMoon}
              className="vai-text-zinc-500"
              size="xs"
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent variant={isDarkMode ? 'dark' : 'default'} side="bottom">
          <p className="vai-font-inter">
            {isDarkMode ? 'Light Mode' : 'Dark Mode'}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
